export const GUEST_PREVIEW_LIMITS = {
  maxPersonalTasks: 3,
  maxTeams: 1,
  maxJournalEntries: 3,
};

export const isGuestPreviewUser = (user) => Boolean(user?.isGuest);
